import { Injectable } from '@angular/core';
import {selectWorldReady} from "../../../state/world/world.selector";
import * as routeSelectors from "../../../state/route/route.selector";
import {worldActions} from "../../../state/world/world.actions";
import {EventsBlueprint} from "./events-blueprint";
import {Store} from "@ngrx/store";
import {BehaviorSubject} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class IsolateEntityService {

  // isolateId = "005c2501-c3c9-4c28-9883-9f2797e1dfdd"
  isolateId = new BehaviorSubject<string>(null)

  constructor(
      private store: Store,
  ) {
    this.store.select(selectWorldReady).subscribe((binstViewReady: boolean) => {
      if (!binstViewReady) {
        return;
      }
      this.store
          .select(routeSelectors.selectQueryParam("isolate"))
          .subscribe((params) => {
            if (!params) return;
            this.isolateId.next(params + "")
            console.log("[Isolate service] Isolating: ", this.isolateId.value)
          });
    });
  }

}
